<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('translationPrice') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'translationPriceList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('translationPriceList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            class="xs"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="4"
            sm="4"
          >
            <aicomplete
              v-model="documentType"
              title="documentType"
              type="setConfig"
              :new-btn="true"
              :rules="[v => !!v || $t('is-required')]"
              :data="JSON.stringify({key:'t_docuemtnType', type:'translation'})"
              :val="documentType"
            />
          </v-col>
          <v-col
            class="xs ps-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <aicomplete
              v-model="fromLanguage"
              title="fromLanguage"
              type="setConfig"
              :rules="[v => !!v || $t('is-required')]"
              :new-btn="true"
              :data="JSON.stringify({key:'t_languages', type:'translation'})"
              :val="fromLanguage"
            />
          </v-col>
          <v-col
            class="xs ps-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <aicomplete
              v-model="toLanguage"
              title="toLanguage"
              type="setConfig"
              :new-btn="true"
              :rules="[v => !!v || $t('is-required')]"
              :data="JSON.stringify({key:'t_languages', type:'translation'})"
              :val="toLanguage"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="xs pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="baseTranslate"
              :dense="true"
              :label="$t('baseTranslate')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              :hideDetails="true"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="specialTranslat"
              :dense="true"
              :label="$t('specialTranslat')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              :hideDetails="true"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="stampTranslator"
              :dense="true"
              :label="$t('stampTranslator')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              :hideDetails="true"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="judicialApproval"
              :dense="true"
              :label="$t('judicialApproval')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              :hideDetails="true"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="officeServices"
              :dense="true"
              :label="$t('officeServices')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="equalOriginal"
              :dense="true"
              :label="$t('equalOriginal')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="foreignApproval"
              :dense="true"
              :label="$t('foreignApproval')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs ps-0 pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="verificationServices"
              :dense="true"
              :label="$t('verificationServices')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              class="mb-4 mt-2 dense"
            />
          </v-col>
          <v-col
            class="xs pb-0"
            cols="12"
            :class="{'mb-3' : $vuetify.breakpoint.mobile}"
            md="3"
            sm="3"
          >
            <money
              v-model="embassy"
              :dense="true"
              :label="$t('embassy')"
              :outlined="true"
              :solo="false"
              value-when-is-empty=""
              :options="options"
              class="mb-4 mt-2 dense"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo(  'yearList' )"
            >
              {{ $t('financialYear') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'Product',
    components: {
      aicomplete,
      Snakbar,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      toLanguage: null,
      fromLanguage: null,
      documentType: null,
      specialTranslat: 0,
      stampTranslator: 0,
      judicialApproval: 0,
      officeServices: 0,
      foreignApproval: 0,
      equalOriginal: 0,
      verificationServices: 0,
      embassy: 0,
      baseTranslate: 0,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      id: null,
      status: 'active',
      group: null,
      loading: false,
    }),
    watch: {
      snakbar () {
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
      }
    },
    mounted () {
    },
    methods: {
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'translationPrice', app.$data)
          .then(res => {
            app.goTo('translationPriceList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'translationPrice/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.documentType = res.documentType
              app.fromLanguage = res.fromLanguage
              app.toLanguage = res.toLanguage
              app.embassy = res.embassy
              app.baseTranslate = res.fee
              app.foreignApproval = res.foreign_approval
              app.judicialApproval = res.judicial_approval
              app.officeServices = res.office_services
              app.specialTranslat = res.special_translation
              app.stampTranslator = res.stamp_translator
              app.equalOriginal = res.equal_original
              app.verificationServices = res.verification_services
              app.other = res.other
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'translationPrice/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo('translationPriceList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
